import { Nullable } from "@/general/custom-types/CustomTypes";

export class SensorFormModel {
  id: Nullable<number>;
  business: Nullable<boolean>;
  billing: Nullable<boolean>;
  virtual: Nullable<boolean>;
  active: Nullable<boolean>;
  aggregatable: Nullable<boolean>;
  calculation: Nullable<string>;
  calculationDescription: Nullable<string>;
  obisNumber: Nullable<string>;
  registerNumber: Nullable<number>;
  forecasted: Nullable<boolean>;
  quarterlyAggregated: Nullable<boolean>;
  hourlyAggregated: Nullable<boolean>;
  dailyAggregated: Nullable<boolean>;
  monthlyAggregated: Nullable<boolean>;
  meterEntity: Nullable<number>;
  report: Nullable<boolean>;
  tableau: Nullable<boolean>;
  sensorTag: Nullable<string>;

  constructor(
    id?: Nullable<number>,
    business?: Nullable<boolean>,
    billing?: Nullable<boolean>,
    virtual?: Nullable<boolean>,
    active?: Nullable<boolean>,
    aggregatable?: Nullable<boolean>,
    calculation?: Nullable<string>,
    calculationDescription?: Nullable<string>,
    obisNumber?: Nullable<string>,
    registerNumber?: Nullable<number>,
    forecasted?: Nullable<boolean>,
    quarterlyAggregated?: Nullable<boolean>,
    hourlyAggregated?: Nullable<boolean>,
    dailyAggregated?: Nullable<boolean>,
    monthlyAggregated?: Nullable<boolean>,
    meterEntity?: Nullable<number>,
    report?: Nullable<boolean>,
    tableau?: Nullable<boolean>,
    sensorTag?: Nullable<string>
  ) {
    this.id = id;
    this.business = business;
    this.virtual = virtual;
    this.active = active;
    this.aggregatable = aggregatable;
    this.calculation = calculation;
    this.calculationDescription = calculationDescription;
    this.obisNumber = obisNumber;
    this.registerNumber = registerNumber;
    this.forecasted = forecasted;
    this.quarterlyAggregated = quarterlyAggregated;
    this.hourlyAggregated = hourlyAggregated;
    this.dailyAggregated = dailyAggregated;
    this.monthlyAggregated = monthlyAggregated;
    this.meterEntity = meterEntity;
    this.report = report;
    this.tableau = tableau;
    this.sensorTag = sensorTag;
  }
}
